








import {Component, Vue} from 'vue-property-decorator'

@Component({})
export default class Header extends Vue {
  private get getLogo() {
    if (process.env.NODE_ENV === 'development') {
      return require('@/assets/logo.png');
    } else {
      return 'https://www.seiringer.at/wp-content/uploads/2021/02/logo.png';
    }
  }

  private get getGuy() {
    if (process.env.NODE_ENV === 'development') {
      return require('@/assets/guy.png');
    } else {
      return 'https://www.seiringer.at/wp-content/uploads/2021/02/guy.png';
    }
  }
}
